export const video__title_color: Record<string, string> = {
  0: "Light",
  1: "Dark",
}
